import root from 'window-or-global';

export default function() {
    /**
     * Enum for URLs for the API endpoints.
     */
    const appContext = root.appContext && root.appContext !== '/' ? root.appContext : '';
    if (!root.location.origin) {
        const port = root.location.port ? `:${root.location.port}` : '';
        root.location.origin = `${root.location.protocol}//${root.location.hostname}${port}`;
    }
    const origin = root.location.origin + appContext;

    const URL = {
        ORIGIN: `${origin}`,

        SUBSCRIBE: {
            ADD: `${origin}/ajax-subscribe-user`,
            CHECK: `${origin}/ajax-is-user-subscribed`
        }
    };

    return URL;
}

